export default class Option {

    id = '';
    name = '';
    country = null;

    constructor() {
    }
}
